<template>
  <div class="act-overlay" >
    <embed src="https://reservations.reserveport.com/static/img/loader.svg" class="act-overlay-icon" />
    <!-- <img :src="'https://reservations.reserveport.com/static/img/loader.png'"  alt="loader"> -->
    <div v-if="percentagIncrease < 100" class="loading_per" id="precent" style="padding:10px">
      {{ percentagIncrease }} %
    </div>
  </div>
</template>
<script>
export default {
  props: {
    thumbnail: {
      type: String
    },
    images: {
      type: Array
    }
  },
  data () {
    return {
      percentagIncrease: 0
    }
  },
  mounted () {
    //
    const perfData = window.performance.timing // The PerformanceTiming interface
    let EstimatedTime = -(perfData.domContentLoadedEventEnd - perfData.navigationStart) // Calculated Estimated Time of Page Load which returns negative value.
    const time = parseInt((EstimatedTime / 1000) % 60) * 100
    this.animateValue(0, 100, time)
  },
  methods: {
    animateValue (start, end, duration) {
      var range = end - start
      let current = start
      const increment = end > start ? 1 : -1
      const stepTime = Math.abs(Math.floor(duration / range))
      var timer = setInterval(() => {
        current += increment
        this.percentagIncrease = current
        if (current === end) {
          clearInterval(timer)
        }
      }, stepTime)
    }
  }
}
</script>
<style scoped>
.act-overlay{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.act-overlay-icon{
  width: 48px;
  height: 48px;
}
</style>



// WEBPACK FOOTER //
// src/components/loader.vue